module.exports = __webpack_public_path__ + "media/images/creator/home/kv-bg-4e0469a568b164bc3a062986e47a06e1.png";